import { render } from "./ReportRemoved.vue?vue&type=template&id=36c8249b"
import script from "./ReportRemoved.vue?vue&type=script&lang=js"
export * from "./ReportRemoved.vue?vue&type=script&lang=js"

import "./ReportRemoved.vue?vue&type=style&index=0&id=36c8249b&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__